import {
  LoadGtag,
  InitDataLayer,
  GtagExists,
  DisableGtag,
  RemoveGtag
} from "./config";

export const loadGtag: LoadGtag = (id, callback) => {
  return new Promise((resolve, reject) => {
    if (!id) reject("[Vue gtag plugin]: No id provided");
    if (typeof document === "undefined") {
      reject("[Vue gtag plugin]: Document is not available");
      return;
    }
    const head: HTMLHeadElement = document.head;
    const gtagScript: HTMLScriptElement = document.createElement("script");

    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    head.appendChild(gtagScript);

    gtagScript.onload = () => {
      if (callback) callback();
      resolve(true);
    };
    gtagScript.onerror = () =>
      reject("[Vue gtag plugin]: Error when loading gtag script");
  });
};

export const initDataLayer: InitDataLayer = (id, conversion_id) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
  if (conversion_id) {
    window.gtag("config", conversion_id);
  }
};

export const gtagExists: GtagExists = () => {
  if (typeof document === "undefined") return false;
  return Array.from(document.getElementsByTagName("script")).some(script =>
    script.src.includes("www.googletagmanager.com/gtag/js")
  );
};

export const removeGtag: RemoveGtag = callback => {
  if (typeof document === "undefined") {
    if (callback) callback();
    return;
  }
  const gtagScript: HTMLScriptElement | undefined = Array.from(
    document.getElementsByTagName("script")
  ).find(script => script.src.includes("www.googletagmanager.com/gtag/js"));

  if (gtagScript === undefined) {
    return;
  } else {
    gtagScript.parentNode?.removeChild(gtagScript);
    if (callback) callback();
  }
};

export const disableGtag: DisableGtag = (id, value = true) => {
  if (typeof window === "undefined") return;
  window[`ga-disable-${id}`] = value;
};
